export const RolesEnum = {
    BackOffice: 'BackOffice',
    Technician: 'Technician',
    Manager: 'Manager',
    Operator: 'Operator'
}

export const CompanyTypesEnum = {
    Tranpo: 'Tranpo',
    Contractor: 'Company',
    Hired: 'Company',
    Benefited: 'Company'
}


// WEBPACK FOOTER //
// ./src/shared/utils/Enums.js